import type { State } from 'redux-store/Store';

export const selectLocale = (state: State) => state.locale.locale;
export const selectLanguages = (state: State) => state.locale.languages;
